import React from 'react';

import { useI18n } from 'i18n/I18nContext';

export interface TrustProofProps {
  className?: string;
  /** Lighter text for use on dark photo heroes */
  onDark?: boolean;
}

const TrustProof = ({ className = '', onDark = false }: TrustProofProps) => {
  const { t } = useI18n();
  const items = [
    t('home.trustFreeMonth'),
    t('home.trustSetup'),
    t('home.trustApps'),
    t('home.trustTeam'),
  ];

  return (
    <ul
      className={`gb-trust-proof ${onDark ? 'gb-trust-proof--on-dark' : ''} ${className}`.trim()}
      aria-label={t('home.trustLabel')}
    >
      {items.map((item, index) => (
        <li key={item}>
          {index > 0 ? (
            <span className="gb-trust-proof__sep" aria-hidden="true">
              ·
            </span>
          ) : null}
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
};

export default TrustProof;



// WEBPACK FOOTER //
// ./src/components/TrustProof.tsx